const currentDate = new Date();

// Преобразуем её в строку формата 'YYYY-MM-DD'
export const formattedDate = currentDate.toISOString().split('T')[0];

export function formatDate(dateString) {
  if (!dateString) return '';

  const [datePart, timePart] = dateString.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hours, minutes, seconds] = timePart.split(':');

  return `${hours}:${minutes}:${seconds} ${day}-${month}-${year}`;
}
